import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestVideos() {
  const latest = articles.slice(0, 6);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-2">
              最新视频
            </h2>
            <p className="text-foreground-600 text-sm">第一时间获取小宝探花最新精彩内容</p>
          </div>
          <Link
            to="/category/latest"
            className="whitespace-nowrap inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latest.map((article, i) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block rounded-lg overflow-hidden bg-background-100 hover:bg-background-200/70 transition-all duration-300"
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/80 group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-xl text-foreground-900 group-hover:text-background-50 ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold font-heading text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}